const isZeno = JSON.parse(process.env.VUE_APP_FEATURE_ZENOTOOLS)
const isAiir_Nistar = process.env.VUE_APP_NAME === "Aiir" || process.env.VUE_APP_NAME === "NistarAds"
const hasSubscriptions = isZeno || isAiir_Nistar

let config = {
  appName: process.env.VUE_APP_NAME,
  isDevelopment: process.env.NODE_ENV === "development",
  isAiir: process.env.VUE_APP_NAME === "Aiir",
  isAiir_Nistar,
  appLogo: process.env.VUE_APP_LOGO,
  isStationAlertsEnabled: process.env.VUE_APP_STATION_ALERTS_ENABLED === "true",
  isRecordPodcastEnabled: process.env.VUE_APP_RECORD_PODCAST_ENABLED === "true",
  isImportPodcastEnabled: process.env.VUE_APP_IMPORT_PODCAST_ENABLED === "true",
  isCreateNewPodcastEnabled: process.env.VUE_APP_CREATE_PODCAST_ENABLED === "true",
  defaultPodcastCreationMethod: process.env.VUE_APP_DEFAULT_PODCAST_CREATION_METHOD,
  isDeleteOwnAccountEnabled: process.env.VUE_APP_DELETE_OWN_ACCOUNT_ENABLED === "true",
  isZeno,
  isSurferNetwork: process.env.VUE_APP_NAME === "SurferNETWORK",
  // Brands with Stripe commerce: a checkout exists to send users to, and plans define quotas.
  // Also picks how PodcastBot is offered — see FeatureFlags/isPodcastBotUpsell and isPodcastBotCreationMethod.
  hasSubscriptions,
  colors: {
    primary: process.env.VUE_APP_THEME_COLOR_PRIMARY,
    primaryLight: process.env.VUE_APP_THEME_COLOR_PRIMARY_LIGHT,
    success: process.env.VUE_APP_THEME_COLOR_SUCCESS,
    danger: process.env.VUE_APP_THEME_COLOR_DANGER,
    warning: process.env.VUE_APP_THEME_COLOR_WARNING,
  },
  automation: JSON.parse(process.env.VUE_APP_FEATURE_AUTOMATION),
  libreTimeUrl: process.env.VUE_APP_LIBRETIME_URL,
  nowPlayingEventSourceURL: process.env.VUE_APP_NOW_PLAYING_EVENT_SOURCE_URL,
  speedtestHost: (process.env.VUE_APP_SPEEDTEST_HOST || "").trim(),
  imageProxyURL: process.env.VUE_APP_IMAGE_PROXY_URL,
  podcastFeedURL: process.env.VUE_APP_PODCAST_FEED_URL,
  copyrightText: process.env.VUE_APP_COPYRIGHT_TEXT,
  copyrightURL: process.env.VUE_APP_COPYRIGHT_URL,
  termsText: process.env.VUE_APP_TERMS_TEXT,
  termsURL: process.env.VUE_APP_TERMS_URL,
  // ads.txt help article and support contact shown on the station ads.txt page; override per brand.
  adsTxtHelpUrl:
    process.env.VUE_APP_ADS_TXT_HELP_URL || "https://help.zeno.fm/en/article/setting-up-adstxt-in-zeno-tools-qzrm70/",
  supportEmail: process.env.VUE_APP_SUPPORT_EMAIL || "support@zenomedia.com",
  isPlanCustomStationsEnabled: process.env.VUE_APP_STRIPE_SUBSCRIPTION_ACCOUNT_CUSTOM_STATIONS_ENABLED
    ? JSON.parse(process.env.VUE_APP_STRIPE_SUBSCRIPTION_ACCOUNT_CUSTOM_STATIONS_ENABLED)
    : false,
}

export { config }
